import { If, location, onMount } from 'cdui-js';
import i18n from '../../../i18n';
import { bootDepositApp, isFundHideNav } from '../deposit/h5-deposit/appBridge';
import { IconBack, IconSuccess } from './icons';
import { leaveTradeProducts, parsePreselect } from './shared';
import './trade-products.css';

const productLabel = () => {
  let product = '';
  try {
    product = String((location.query as Record<string, string> | undefined)?.product ?? '');
  } catch {
    product = '';
  }
  if (!product && typeof window !== 'undefined') {
    product = new URLSearchParams(window.location.search).get('product') || '';
  }
  const key = parsePreselect(product);
  if (key === 'chinaConnect') return i18n.TradeProducts.ChinaConnect;
  if (key === 'derivatives') return i18n.TradeProducts.Derivatives;
  return i18n.TradeProducts.Title;
};

export const TradeProductsSuccess = () => {
  const hideNav = isFundHideNav();

  onMount(() => {
    void bootDepositApp().catch(() => {});
  });

  return (
    <div class="trade-products-h5">
      <If when={!hideNav}>
        <div class="nav">
          <button type="button" class="nav-back" onclick={() => leaveTradeProducts()}>
            <IconBack />
          </button>
          <div class="nav-title">{i18n.TradeProducts.Title}</div>
        </div>
      </If>

      <div class="tp-success-body">
        <div class="tp-success-icon">
          <IconSuccess />
        </div>
        <div class="tp-success-title">{i18n.TradeProducts.SuccessTitle}</div>
        <div class="tp-success-desc">
          {productLabel()}
          {i18n.TradeProducts.SuccessMessage}
        </div>
      </div>

      <div class="tp-footer">
        <button type="button" class="tp-submit" onclick={() => leaveTradeProducts()}>
          {i18n.TradeProducts.Done}
        </button>
      </div>
    </div>
  );
};

export default TradeProductsSuccess;
